<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md6 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-chart-line</v-icon>
            <v-toolbar-title class="ml-1">Формы ввода</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openInputForm(null)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
              <span>Добавить форму ввода</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn small icon slot="activator" @click="openFolderForm(null, 'form')" class="mx-0"><v-icon class="mx-0">mdi-folder-plus</v-icon></v-btn>
              <span>Создать новую папку</span>
            </v-tooltip>
          </v-system-bar>
          <v-card-text class="px-0 py-2">
            <v-text-field
              class="mx-2 mt-0 mb-2 pt-0"
              v-model="searchform"
              label="Фильтр"
              hide-details
              single-line
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
            
            <v-treeview :items="forms" item-key="key" class="densed pb-1 ovflowxscroll" :search="searchform">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" :color="item.iconcolor" @contextmenu="openMenu($event, item, 'form')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="" @contextmenu="openMenu($event, item, 'form')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md6 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-account-check</v-icon>
            <v-toolbar-title class="ml-1">Доступ на признаки</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn small icon slot="activator" @click="openAccessForm(null)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
              <span>Добавить доступ</span>
            </v-tooltip>
          </v-system-bar>
          <v-card-text class="px-0 py-2">
            <v-text-field
              class="mx-2 mt-0 mb-2 pt-0"
              v-model="searchwatch"
              label="Фильтр"
              hide-details
              single-line
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
            
            <v-treeview :items="watchers" item-key="watcher_id" class="densed pb-1 ovflowxscroll" :search="searchwatch">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" :color="item.iconcolor" @contextmenu="openMenu($event, item, 'form')">mdi-account-check</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="showObjects(item)" @contextmenu="openMenu($event, item, 'access')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
      <v-list id="analytics-objects-menu">
        <v-list-tile @click="editItem">
          <v-list-tile-action><i class="mdi mdi-pencil"></i></v-list-tile-action>
          <v-list-tile-title>Редактировать</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="openFolderForm(null, 'form', currentObject.id)" v-if="currentObject && currentObject.element_type==='folder'">
          <v-list-tile-action><i class="mdi mdi-folder-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить папку</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="openInputForm(null, currentObject.id)" v-if="currentObject && currentObject.element_type==='folder'">
          <v-list-tile-action><i class="mdi mdi-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить форму ввода</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="deleteItem">
          <v-list-tile-action><i class="mdi mdi-delete"></i></v-list-tile-action>
          <v-list-tile-title>Удалить</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    
    <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import FolderForm from './Forms/FolderForm'
  import InputForm from './Forms/InputForm'
  import AccessForm from './Forms/AccessForm'
  import AccessList from './Forms/AccessList'
  
  import {mapState} from 'vuex'
  import entities from '@/mixins/entities'
  
  export default {
    name : "Access",
    
    mixins: [entities],
    
    computed:{
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      ...mapState(`analytics/constructor`, ['propertiesTree', 'forms']),
      accesses: function() {
        return this.$store.state.app.account.accesses['analytics'] || {}
      }
    },
    
    data(){
      return {
        dialog: false,
        currentComponent: null,
        formProps: {},
        dialogWidth: 1100,
        org_tree: [
          { id: 'org', name: 'Оргструктура', children: []}
        ],
        searchform: null,
        searchwatch: null,
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        currentObject: null,
        watchers: []
      }
    },
    
    created() {
      if (!this.accesses.property_access){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      } else {
        this.getTrees()
      }
    },
    
    methods:{
      openMenu(e, item, tree){
        e.preventDefault()
        if(item.id!=='root'){
          this.currentObject = item
          this.menu.show = false
          this.menu.x = e.clientX
          this.menu.y = e.clientY
          this.$nextTick(() => {
            this.menu.show = true
          })
        }
      },
      
      getTrees(){
        //Загрузка дерева объектов
        this.$store.dispatch('analytics/constructor/getProperties', 'other')
        this.$store.dispatch('analytics/constructor/getObjects')
        
        //Загрузка дерева форм ввода
        this.$store.dispatch('analytics/constructor/getFormsTree')
        
        //Загрузка дерева оргструктуры
        this.$store.dispatch('app/org/tree', 'other').then( tree => {
          this.org_tree[0].children = tree
        })
        
        //Загрузка наблюдателей (кому дан доступ к признакам)
        this.$store.dispatch('analytics/constructor/getWatchers').then( watchers => {
          this.watchers = watchers
          this.convertArrayobjects(this.watchers, 'watcher_id', 'watcher_type')
        })
      },
      
      openFolderForm(data = null, type, parent_id = null){
        this.currentComponent = FolderForm
        this.formProps = {
          type
        }
        if(data!=null){
          this.formProps = {
            editMode: true,
            data,
            type
          }
        } else if(parent_id!=null){
          this.formProps.data = {
            name: '',
            description: '',
            parent_id
          }
        }
        this.dialogWidth = 600
        this.dialog = true
      },
      
      openInputForm(data = null, parent_id = null){
        this.currentComponent = InputForm
        this.formProps = {}
        if(data!=null){
          this.formProps = {
            editMode: true,
            data: data
          }
        } else if(parent_id!=null){
          this.formProps.data = {
            name: '',
            description: '',
            parent_id,
            multiscope: false,
            lines: [],
            scope: []
          }
        }
        this.dialogWidth = 1100
        this.dialog = true
      },
      
      openAccessForm(data = null){
        let objects = this.propertiesTree.concat(this.org_tree)
        
        this.currentComponent = AccessForm
        this.formProps = {
          objects
        }
        if(data!=null){
          data.elements = []
          this.formProps = {
            editMode: true,
            data,
            objects
          }
        }
        
        this.dialogWidth = 1100
        this.dialog = true
      },
      
      editItem(){
        let type = 'form'
        switch(this.currentObject.element_type){
          case 'folder':
            this.openFolderForm(this.currentObject, type)
            break
          case 'setting':
            this.openInputForm(this.currentObject)
            break
          case 'watcher':
            this.openAccessForm(this.currentObject)
            break
        }
      },
      
      deleteItem(){
        switch(this.currentObject.element_type){
          case 'folder':
            this.$dmsAgree('Вы уверены, что хотите удалить папку и все вложенные элементы?').then( _ => {
              this.$store.dispatch('analytics/constructor/deleteFolder', {id: this.currentObject.id, trash: false, type: 'form'}).catch( error => {
                let message = 'Возникла ошибка при удалении папки'
                if(error.response && error.response.data.message){
                  message = error.response.data.message
                }
                this.$dmsErrorNoty(message)
              })
            })
            break
          case 'setting':
            this.$dmsAgree('Вы уверены, что хотите удалить форму ввода?').then( _ => {
              this.$store.dispatch('analytics/constructor/deleteEntity', {id: this.currentObject.id, type: 'form'}).catch( error => {
                let message = 'Возникла ошибка при удалении формы ввода'
                if(error.response && error.response.data.message){
                  message = error.response.data.message
                }
                this.$dmsErrorNoty(message)
              })
            })
            break
          case 'watcher':
            this.$dmsAgree('Вы уверены, что хотите удалить все назначенные доступы?').then( _ => {
              let data = {
                watcher_id: this.currentObject.watcher_id,
                watcher_type: this.currentObject.watcher_type,
                elements: []
              }
              this.$store.dispatch('analytics/constructor/addWatcher', data).then(response => {
                this.updateWatcher(data)
              }).catch( error => {
                let message = 'Возникла ошибка при удалении объекта'
                if(error.response && error.response.data.message){
                  message = error.response.data.message
                }
                this.$dmsErrorNoty(message)
              })
            })
            break
        }
      },
      
      showObjects(item){
        this.$store.dispatch('analytics/constructor/assignedObjects', {id: item.watcher_id, type: item.watcher_type}).then( response => {
          this.currentComponent = AccessList
          this.formProps = {
            objects: response
          }
          this.dialogWidth = 600
          this.dialog = true
        })
      },
      
      saveChanges(eventData){
        switch(eventData.type){
          case 'watcher':
            this.updateWatcher(eventData.data)
            break
        }
        this.dialog = false
      },
      
      updateWatcher(watcher){
        let index = this.watchers.findIndex( el => el.watcher_id === watcher.watcher_id)
        if(watcher.elements.length===0){
          if(index>-1) this.watchers.splice(index, 1)
        } else {
          if(index<0) this.watchers.push(watcher)
        }
      }
    }
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Access.vue